/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TwitterThreadLayout} from "../../layouts/TwitterThreadLayout";
import {TwitterThreadBlock, TwitterThreadAuthor, TwitterThreadOriginalUrl, TwitterThreadBlockFirst} from "../../components/TwitterThread";
export const meta = {
  url: "https://devsforgood.com/thread/how-to-learn-web-development",
  title: "How to learn Web Development",
  description: `How Should I Learn Web Development? A Thread...`,
  image: "/covers/threads/how-to-learn-web-development.png",
  author: "Ankur💻🎧💪"
};
const MDXLayout = ({children}) => _jsx(TwitterThreadLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    ul: "ul",
    li: "li",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(TwitterThreadAuthor, {
      name: "Ankur💻🎧💪",
      username: "TheAnkurTyagi",
      avatarUrl: "/avatars/TheAnkurTyagi.png"
    }), "\n", _jsx(TwitterThreadOriginalUrl, {
      url: "https://twitter.com/TheAnkurTyagi/status/1408105497455218688"
    }), "\n", _jsxs(TwitterThreadBlockFirst, {
      image: `/images/how-to-learn-web-development-0.png`,
      children: [_jsx(_components.p, {
        children: "How Should I Learn Web Development?"
      }), _jsx(_components.p, {
        children: "A Thread..."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "As a mentor, I am constantly asked the following:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "Which programming language should I learn if I’m new?"
        }), "\n", _jsx(_components.li, {
          children: "Which programming language is most in-demand for jobs?"
        }), "\n", _jsx(_components.li, {
          children: "What’s the most popular programming language?"
        }), "\n"]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/how-to-learn-web-development-2.png`,
      children: [_jsx(_components.p, {
        children: "As per the 2020 StackOverflow survey,"
      }), _jsx(_components.p, {
        children: "Most Popular Technologies are like this 👇"
      }), _jsx(_components.p, {
        children: "That list is great for checking whether a particular programming language is in use today."
      }), _jsx(_components.p, {
        children: "However, if you’re new to programming, I don’t recommend choosing a language solely based on a list."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "In my Engineering days, studying Computer and Science Engineering."
      }), _jsx(_components.p, {
        children: "I wasn't at all interested in coding and all that tech stuff."
      }), _jsx(_components.p, {
        children: "Until one day, my Mentor recommended a Udemy Course to me on Web Development."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "Well, I ended up watching the course two hours a day because I liked it."
      }), _jsx(_components.p, {
        children: "But at that time I wasn't practicing coding on my laptop like many of you."
      }), _jsx(_components.p, {
        children: "Within days, I learned the basics of HTML and CSS."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "Before you begin learning how to code,"
      }), _jsx(_components.p, {
        children: "The biggest mistake you can make as an aspiring programmer is giving up because you don’t think you’re smart enough to learn to program."
      }), _jsx(_components.p, {
        children: "Learning to code has nothing to do with your intelligence."
      }), _jsx(_components.p, {
        children: "Yes, it’s difficult to learn to program."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "If the current topic you’re learning doesn’t make sense to you, stay where you are."
      }), _jsx(_components.p, {
        children: "Do not proceed to the next topic."
      }), _jsx(_components.p, {
        children: "Skipping ahead is like trying to attach a roof to a house that lacks a frame, walls, and a foundation."
      }), _jsx(_components.p, {
        children: "\"I find myself in this situation all the time.\""
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "If you’re searching on YouTube for educational tutorials, check the stats first."
      }), _jsx(_components.p, {
        children: "Take a quick look at the rating and/or the view count."
      }), _jsx(_components.p, {
        children: "If you’re still unsure if a video is worth your time, read some of the comments to gage others’ opinions."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "A lot of topics aren’t going to make sense the first time around."
      }), _jsx(_components.p, {
        children: "So, refrain from negative self-thoughts."
      }), _jsx(_components.p, {
        children: "As you progress through the learning path,"
      }), _jsx(_components.p, {
        children: "You need to self-reflect."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "You can focus on front-end development OR back-end development."
      }), _jsx(_components.p, {
        children: "For e.g."
      }), _jsx(_components.p, {
        children: "For Front-end development, you need to learn HTML, CSS, JavaScript, and a library or frameworks like React, Angular, or Vue.js."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "JavaScript is a programming language used to help web pages be more interactive."
      }), _jsx(_components.p, {
        children: "While HTML and CSS give structure and style to web pages, JavaScript provides web pages with interactive elements that engage a user."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "No, you don’t have to be strong in math to be a programmer."
      }), _jsx(_components.p, {
        children: "Math skills can be helpful, but they’re not necessary."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "Leverage \"Stack Overflow\""
      }), _jsx(_components.p, {
        children: "Where programmers can get free help with their code."
      }), _jsx(_components.p, {
        children: "If you get stuck and want to ask a question, search for it first."
      }), _jsx(_components.p, {
        children: "If you can’t find your question, create an account and post the question yourself!"
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "If you want to learn to code, this is the best time:"
      }), _jsx(_components.p, {
        children: "And to motivate you, here are some facts:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "There are a ton of great and high-quality free resources out there. Yes, you can learn everything related to Web Development for free."
        }), "\n", _jsx(_components.li, {
          children: "You can earn money in numerous tech-fields."
        }), "\n"]
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "Best website I've ever visited in my life is freeCodeCamp."
      }), _jsx(_components.p, {
        children: "Then you can find good courses on Udemy & YouTube."
      }), _jsx(_components.p, {
        children: "With the help of HTML, CSS, Javascript, and any of the frameworks. Try to build projects."
      }), _jsx(_components.p, {
        children: "By contributing to open-source projects, you will learn a lot."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "As a self-starter, you should always be willing to ask the right questions."
      }), _jsx(_components.p, {
        children: "This is by far the greatest skill to have."
      }), _jsx(_components.p, {
        children: "As a self-starter, you must always be willing to take risks."
      }), _jsx(_components.p, {
        children: "Also, you shouldn’t postpone things."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "Ending Thread with below quote:"
      }), _jsx(_components.p, {
        children: "We should not judge people by their peak of excellence, but by the distance, they have traveled from the point where they started."
      }), _jsx(_components.p, {
        children: "— Henry Ward Beecher"
      }), _jsx(_components.p, {
        children: "Follow me (@TheAnkurTyagi) to watch more stories like this."
      })]
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "Thanks for reading. If you like this might be you are interested in my Book as well."
      }), _jsx(_components.p, {
        children: "I have written a book for developer growth & shared my 11+ years of experience."
      }), _jsx(_components.p, {
        children: "Currently running on 50% discount, only $9.50"
      }), _jsx(_components.p, {
        children: _jsx(_components.a, {
          href: "https://theankurtyagi.gumroad.com/l/nextgendev/gumroad",
          children: "https://theankurtyagi.gumroad.com/l/nextgendev/gumroad"
        })
      })]
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
